import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname } = useLocation();
  const loadTime = useRef(Date.now());

  useEffect(() => {
    window.scrollTo(0, 0);
    // 页面加载超过24小时后，下次路由跳转自动刷新获取最新版本
    if (Date.now() - loadTime.current > 24 * 60 * 60 * 1000) {
      window.location.reload();
    }
  }, [pathname]);

  return null;
}